<template>
    <div class="financial-bill-filter" :class="{ open: openState}" v-bind:style="{'top': filterTop}">
        <div class="financial-bill-filter-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <!-- <div class="default notify">
                <div class="title level1-title-font">催款狀態</div>
                <rent-select  refName="notify" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterCountyIsEmpty">
                    <ul>
                        <li data-id="1">
                            已催款
                        </li>
                        <li data-id="0">
                            未催款
                        </li>
                    </ul>
                </rent-select>
            </div> -->
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterCountyIsEmpty">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.district.state">
                        <ul v-if="financialBillFilter.countyId">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">帳單金額</div>
                <vue-slider v-model="financialBillFilter.amount" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterResultTotal}}
                </div>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/widge/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            openState: this.isOpen,
            financialBillFilter: {
                county: '',
                countyId: '',
                district: '',
                amount: [0, 100000],
                notify: ''
            },
            isDefault: false,
            filterState: 0,
            address: {
                county: {
                    state: false,
                    msg: '所有縣市'
                },
                district: {
                    state: false,
                    msg: '所有區域'
                },
                road: {
                    state: false,
                    msg: '所有路段'
                }
            },
            filterResultTotal: 0,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        this.getHashForResultTotal()
        window.addEventListener('scroll', this.handleScroll);

    },
    destroyed () {
        this.$store.dispatch('setFinancialBillFilterDefault')
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        financialBillFilter: {
            handler: function () {
                this.$emit('changeFilter', this.financialBillFilter)
                this.filterState = 1
            },
            deep: true
        },
        filterTotal: {
            handler: function () {
                this.getHashForResultTotal()
            },
            deep: true
        },
        $route(to, from) {
            // console.log('routeChange')
            this.getHashForResultTotal()
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            this.filterTop = (scrollTop-163) + 'px'
                
        },
        setFilterDefault: function () {
            this.financialBillFilter = {
                county: '',
                countyId: '',
                district: '',
                amount: [0, 100000],
                notify: ''
            },
            setTimeout(()=>{
                this.filterState = 0
            },100)
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getHashForResultTotal: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#全部' ){
                this.filterResultTotal = this.filterTotal.all
            }else if( hashTag == '#欠款' ){
                this.filterResultTotal = this.filterTotal.overdue
            }else if( hashTag == '#已繳' ){
                this.filterResultTotal = this.filterTotal.paid
            }else if( hashTag == '#未繳' ){
                this.filterResultTotal = this.filterTotal.unpaid
            }else{
                this.filterResultTotal = this.filterTotal.all
            }
        },
        getSelectId: function (value) {
            if( value.ref == 'county' ){
                this.address.district.state = true
                this.financialBillFilter.district = null

                this.financialBillFilter.county = value.name
                this.financialBillFilter.countyId = value.id
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.address.district.state = false
                this.financialBillFilter.district = value.name
            }else if( value.ref == 'notify' ){
                this.financialBillFilter.notify = value.id
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // }
    },
    computed: {
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            filterTotal: 'GET_FINANCIAL_BILL_MGT_FILTER_RESULT_TOTAL',
            filterCountyIsEmpty: 'GET_FINANCIAL_BILL_MGT_FILTER_COUNTY_IS_EMPTY',
            filterDistrictIsEmpty: 'GET_FINANCIAL_BILL_MGT_FILTER_DISTRICT_IS_EMPTY',
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .financial-bill-filter{
        position: absolute;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: -164px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .financial-bill-filter-wrap{
            position: relative;
            height: 100%;
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .financial-bill-filter.open{
        right: -40px;
    }
    @media screen and (max-width: 1280px) {
        .financial-bill-filter.open{
            right: 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/financialBillFilter.vue